<template>
  <div class="flex items-center p-0.5 h-5">
    <input
      :checked="checked"
      :disabled="disabled"
      :value="value"
      v-bind="$attrs"
      :id="id"
      type="checkbox"
      :class="[
        disabled
          ? ' !cursor-not-allowed border-gray-200 text-gray-400'
          : 'cursor-pointer text-primary border-brand-gray-600'
      ]"
      class="size-4 accent-primary"
      @change="handleCheckboxChange"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const emits = defineEmits(['change', 'select'])

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  checked: {
    type: Boolean,
    default: false
  },
  value: {
    type: [String, Number, Boolean],
    default: null
  },
  selectedId: {
    type: Array,
    default: () => []
  }
})

function handleCheckboxChange(event) {
  emits('select', event.target.checked)
  emits('change', event)
}
</script>
